export default __webpack_public_path__ + "static/media/ic_globe.31f81707.svg";